import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Playlist } from '@model/playlist';

@Component({
    selector: 'tun-search-text-view',
    templateUrl: './search-text-view.component.html',
    styleUrls: ['./search-text-view.component.scss'],
    standalone: false
})
export class SearchTextViewComponent{

  @Input() canReceiveFocus = false;

  @Output() back = new EventEmitter<void>();

  onBack(){
    this.back.emit();
  }
}
